import React, { useEffect, useState } from "react";
import { Container, Row } from "reactstrap";
import { PageTitle } from "../../../../components/common";
import FullscreenLoader from "../../../../layouts/FullScreenLoader";
import SearchWatchListMultipleEntries from "../../components/search-watch-list-multiple-entries/SearchWatchListMultipleEntries";
import "./watchListEntriesMultipleSearchPage.css";
import {
  nationalitiesOptionsSelector,
  noEntriesMessageWatchListMultipleSearchSelector,
  watchListMultipleSearchEntriesLoadingSelector,
  watchListMultipleSearchEntriesPageInfoSelector,
  watchListMultipleSearchEntriesSelector,
} from "../../selectors";
import { useDispatch, useSelector } from "react-redux";
import { getNationalities } from "../../../../actions";
import {
  changeCurrentPageWatchListMultipleSearchEntries,
  changeItemsPerPageWatchListMultipleSearchEntries,
  clearWatchListMultipleSearchEntries,
} from "../../actions";
import Pagination from "../../../../components/Pagination/Pagination";
import NoEntriesMessage from "../../../../components/common/NoEntriesMessage/NoEntriesMessage";
import WatchListEntriesTable from "../../components/watch-list-entries-table";

const WatchListMultiplePage = () => {
  const dispatch = useDispatch();

  const [isOpenCollapse, setIsOpenCollapse] = useState(true);
  const [currentItems, setCurrentItems] = useState([]);

  const toggleCollapse = () => setIsOpenCollapse(!isOpenCollapse);
  const isLoading = useSelector(watchListMultipleSearchEntriesLoadingSelector);
  const watchListMultipleSearchEntries = useSelector(
    watchListMultipleSearchEntriesSelector
  );
  const { itemsPerPage, currentPage } = useSelector(
    watchListMultipleSearchEntriesPageInfoSelector
  );
  const noEntriesMessage = useSelector(
    noEntriesMessageWatchListMultipleSearchSelector
  );

  const nationalities = useSelector(nationalitiesOptionsSelector);

  useEffect(() => {
    dispatch(getNationalities());
    return () => {
      dispatch(clearWatchListMultipleSearchEntries());
    };
  }, []);

  useEffect(() => {
    if (watchListMultipleSearchEntries.length > 0) {
      setCurrentItems(watchListMultipleSearchEntries.slice(0, itemsPerPage));
    }
  }, [watchListMultipleSearchEntries]);

  const onPageChange = (_, page) => {
    const startFrom = page * itemsPerPage;
    const slicedItems = watchListMultipleSearchEntries.slice(
      startFrom,
      (page + 1) * itemsPerPage
    );

    dispatch(changeCurrentPageWatchListMultipleSearchEntries(page + 1));
    setCurrentItems(slicedItems);
  };

  const onRowsPerPageChange = ({ target }) => {
    dispatch(changeCurrentPageWatchListMultipleSearchEntries(1));
    const slicedItems = watchListMultipleSearchEntries.slice(0, target.value);
    dispatch(
      changeItemsPerPageWatchListMultipleSearchEntries(
        parseInt(target.value, 10)
      )
    );
    setCurrentItems(slicedItems);
  };

  const handleDelete = (id) => {
    // dispatch(deleteWatchListEntry(id));
  };
  return (
    <Container className="watch-list-multiple-search-main col-12">
      <PageTitle title="multiple manual search" />
      <FullscreenLoader loading={isLoading} />

      <SearchWatchListMultipleEntries
        isOpenCollapse={isOpenCollapse}
        toggleCollapse={toggleCollapse}
        watchListMultipleEntries={[]}
        nationalities={nationalities}
      />

      {watchListMultipleSearchEntries.length ? null : (
        <div className="watch-list-multiple-search-page-background-logo" />
      )}

      {watchListMultipleSearchEntries.length > 0 ? (
        <React.Fragment>
          <WatchListEntriesTable
            canEdit={false}
            watchListEntries={currentItems}
            handleDelete={handleDelete}
          />
          {watchListMultipleSearchEntries.length && (
            <Row className="pagination-row mt-5 mb-5">
              <Pagination
                count={watchListMultipleSearchEntries.length}
                onPageChange={onPageChange}
                onRowsPerPageChange={onRowsPerPageChange}
                rowsPerPage={itemsPerPage}
                page={currentPage - 1}
              />
            </Row>
          )}
          {isOpenCollapse && watchListMultipleSearchEntries.length ? (
            <div className="overlay-collapse-open" onClick={toggleCollapse} />
          ) : null}
        </React.Fragment>
      ) : (
        <NoEntriesMessage payload={noEntriesMessage} />
      )}
    </Container>
  );
};

export default WatchListMultiplePage;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/pages/watch-list-entries-multiple-search-page/WatchListEntriesMultipleSearchPage.jsx